
<template>

    <main>

        <transition name="modal">
            <modal
                :employee_id="modal_employee_id"
                @close="() => {
                    modal_employee_id = null
                    refresh()
                }"
                v-if="modal_employee_id"
            />
        </transition>

        <button class="btn btn-primary btn-register" @click="createEmployee()" :disabled="loadingCreateEmployee == true">
            <span class="spinner-border spinner-border-sm me-1"></span>
            <img src="/images/card/register-button-icon.svg">
            Lägg till
        </button>

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <div class="page-body employee-body" style="min-height: 900px;" v-if="fetcher.initialized">

            <div class="container-fluid">
                <h1 class="mb-8">{{ pageTitle }}</h1>

                <div class="row mb-5">

                    <div class="col-24 col-sm-12 col-lg-5">
                        <input type="text" class="form-control form-control-list" placeholder="Sök anställda..." v-model="settings.query.text">
                    </div>
                    <div class="col-24 col-sm-12 col-lg-4 d-none d-sm-block">
                        <select class="form-select form-control-list" v-model="settings.query.status">
                            <option :value="null">Status</option>
                            <option>Inbjuden</option>
                            <option>Aktiverad</option>
                            <option>Inaktiverad</option>
                        </select>
                    </div>
                    <div class="col-24 col-sm-12 col-lg-4 d-none d-sm-block mt-sm-4 mt-lg-0">
                        <select class="form-select form-control-list" v-model="settings.query.workplace" v-if="show_employee_workplace_column">
                            <option :value="null">Arbetsplats</option>
                            <option :key="'w'+workplace.value" :value="workplace.value" v-for="workplace in workplaces">{{ workplace.label }}</option>
                        </select>
                    </div>

                    <div class="col-24 col-sm-12 col-lg-4 d-none d-sm-block mt-sm-4 mt-lg-0">

                    </div>

                    <div class="col-md-8 col-lg-7 d-none d-lg-flex justify-content-end align-content-start">
                        <button class="btn btn-primary me-2" @click="createEmployee()" :disabled="loadingCreateEmployee == true">
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            +<span class="d-none d-xl-inline"> Lägg till</span>
                        </button>

                        <button class="btn btn-outline-primary" @click="openExportModal()">Exportera</button>

                    </div>

                </div>

                <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
                    <div slot="item-row" slot-scope="props">
                        <div class="row g-3" :class="{'inactive': props.item.disabled_at }">
                            <div class="col-12 col-md-5 col-xl-5">
                                <span v-if="props.item.name == ''"><i>Ny anställd</i></span>
                                <span v-else>{{ props.item.name }}</span>
                            </div>
                            <div class="col-md-6 col-xl-5 d-none d-md-flex">
                                <span>{{ props.item.workplace_title }}</span>
                            </div>
                            <div class="col-md-4 col-xl-3 d-none d-md-flex">
                                <span>{{ props.item.created_at }}</span>
                            </div>
                            <div class="col-xl-3 d-none d-xl-flex">
                                <span>{{ props.item.num_treatments }}</span>
                            </div>
                            <div class="col-xl-3 d-none d-xl-flex">
                                <span>{{ props.item.last_treatment_at }}</span>
                            </div>
                            <div class="col-12 col-md-9 col-xl-5 d-flex justify-content-end">

                                <span v-if="props.item.disabled_at">
                                    <poster-button
                                        btn-class="btn btn-outline-info btn-sm"
                                        :url="'/data/employees/' + props.item.id + '/disableAccount'"
                                        @success="activateSuccess()">
                                        <span v-if="props.item.disabled_at">Återaktivera kontot</span>
                                        <span v-else>Inaktivera kontot</span>
                                    </poster-button>
                                </span>
                                <span v-else>
                                    <poster-button
                                        btn-class="btn btn-outline-primary btn-sm me-1"
                                        :url="'/data/employees/' + props.item.id + '/sendAppUrl'"
                                        @success="sendAppUrlSuccess()">
                                        <img src="/images/company-portal/icon-smartphone.svg" class="inactive"><img src="/images/company-portal/icon-smartphone-white.svg" class="active">
                                        <div class="tooltip-label">Skicka en notis med länk till webappen.</div>
                                    </poster-button>

                                    <poster-button
                                        btn-class="btn btn-outline-primary btn-sm me-1"
                                        :url="'/data/employees/' + props.item.id + '/sendForgotPassword'"
                                        @success="sendForgotPasswordSuccess()">
                                        <img src="/images/company-portal/icon-renew.svg" class="inactive"><img src="/images/company-portal/icon-renew-white.svg" class="active">
                                        <div class="tooltip-label">Skicka en notis med återställningslänk för lösenord.</div>
                                    </poster-button>

                                    <button class="btn btn-outline-primary btn-sm" @click="modal_employee_id = props.item.id">
                                        <img src="/images/company-portal/icon-edit.svg" class="d-sm-none"><span class="d-none d-sm-block">Hantera</span>
                                        <div class="tooltip-label">Redigera uppgifter, visa lista på behandlingar eller ta bort kontot.</div>
                                    </button>
                                </span>

                            </div>
                        </div>
                    </div>
                </list>

            </div>

        </div>

    </main>

</template>

<script>
import axios from 'axios'

import scrollMixin from '../../../shared/mixins/scrollMixin'
import lister from '../../../shared/mixins/lister'
import fetcher from '../../../shared/mixins/fetcher'

import modal from './modal'
import PosterButton from '../../../shared/components/poster-button'

export default {

    mixins: [
        scrollMixin,
        lister,
        fetcher
    ],

    components: {
        PosterButton,
        modal
    },

    data () {
        return {
            pageTitle: 'Anställda',
            foldRow: false,
            modal_employee_id: null,
            loadingCreateEmployee: false,

            workplaces: [],
            dynamicFields: [],
            show_employee_workplace_column: false,
            fetcher: {
                autoFill: [
                    'workplaces',
                    'dynamicFields',
                    'show_employee_workplace_column'
                ]
            },

            settings: {
                url: '/data/employees/list',
                query: {
                    text: '',
                    status: null,
                    workplace: null
                },
                columns: [
                    { column: 'name', name: 'Namn', class: 'col-16 col-md-5 col-xl-5', sortable: true, default: true },
                    { column: 'workplace_title', name: 'Arbetsplats', class: 'col-md-6 col-xl-5 d-none d-md-flex', sortable: true },
                    { column: 'created_at', name: 'Registrerad', class: 'col-md-4 col-xl-3 d-none d-md-flex', sortable: true },
                    { column: 'num_treatments', name: 'Antal beh.', class: 'col-xl-3 d-none d-xl-flex', sortable: true },
                    { column: 'last_treatment_at', name: 'Senaste beh.', class: 'col-xl-3 d-none d-xl-flex', sortable: true },
                    { column: 'buttons', name: '', class: 'col-12 col-md-9 col-xl-5', sortable: false }
                ],
                bulk_actions: [],
                export_fields: [
                    { column: 'id', name: 'ID' },

                    { column: 'status', name: 'Status' },
                    { column: 'created_at', name: 'Registrerad/skapad' },
                    { column: 'invited_at', name: 'Inbjuden' },
                    { column: 'activated_at', name: 'Aktiverad' },

                    { column: 'last_treatment_at', name: 'Senaste behandling' },
                    { column: 'treatments_count', name: 'Antal behandlingar' }
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/data/employees'
        }
    },

    methods: {

        fetcherSuccess (data) {
            if (!this.show_employee_workplace_column) {
                this.settings.columns = this.settings.columns.filter(c => c.column !== 'employee_workplace_title')

                // this.settings.columns[2].class = 'col-1' // ändrar part_payment klassen, då den nu har index 2
            }

            let spliceAtIndex = 1
            this.dynamicFields.forEach(d => {
                if (d.is_active && d.type !== 'password') {
                    this.settings.export_fields.splice(spliceAtIndex, 0, {
                        column: d.type !== 'text' ? d.type : 'dynamic_field_' + d.id,
                        name: d.label
                    })

                    spliceAtIndex++
                }
            })
        },
        createEmployee () {
            this.loadingCreateEmployee = true
            axios.post('/data/employees')
                .then(response => {
                    this.modal_employee_id = response.data.employee_id
                    this.loadingCreateEmployee = false
                })
        },
        activateSuccess () {
            this.refresh()
            bus.$emit(
                'notify',
                'Kontot har återaktiverats'
            )
        },
        sendAppUrlSuccess () {
            bus.$emit(
                'notify',
                'Notisen med länk har skickats'
            )
        },
        sendForgotPasswordSuccess () {
            bus.$emit(
                'notify',
                'Notis med återställningslänk har skickats'
            )
        }
    }
}
</script>
<style type="text/css">
/* --- Fade transition --- */
.modal-enter-active, .modal-leave-active {
    opacity: 1;
    transition: all 250ms;
}

.modal-enter-active .custom-modal-window, .modal-leave-active .custom-modal-window {
    transform:translate(0, 0);
    transition: all 250ms;
}

.modal-enter, .modal-leave-to {
    opacity: 0;
}

.modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
    transform:translate(0, -50px);
}

@media only screen and (max-width: 768px){

    .modal-enter, .modal-leave-to {
        opacity: 1;
    }

    .modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
        transform:translate(0, 100%);
    }

}
</style>
